import cookies from 'browser-cookies';
import escape from './escape';

function parseCookie(cookie) {
  const pairs = cookie.split('&amp;$').map((pair) => {
    const splittedPair = pair.split('=');
    return {
      key: splittedPair[0],
      value: splittedPair[1],
    };
  });
  return pairs;
}

function getPairFromKey(pairs, key) {
  return pairs.find(pair => pair.key === key);
}

/**
   * This function retrieves a cookie value by the given indentifier.
   *
   * If the cookie with the indentifier doesn't exists, you can pass a
   * second argument as a fallback to return it so we avoid polluting the
   * Form with stuff like `|| ''` or `|| otherValue`
   * @param {string} identifier
   * @param {any} fallback – Defaults to null
   */
function getValueFromCookie(identifier, property, fallback = null) {
  // cookies.get(identifier) returns `null` if no cookie has been found
  const cookie = cookies.get(identifier);
  if (!cookie) {
    return fallback;
  }
  // We space the cookie to avoid possible XSS and injections
  const escapedCookie = escape(cookie);
  const pairs = parseCookie(escapedCookie);
  return getPairFromKey(pairs, property).value;
}

export default getValueFromCookie;
